import Logger from 'Logger'
import _ from 'underscore'
import { API_ENDPOINT, LINK, TRACKING_CODE, STATUS } from '../config'
import { loadingModel } from '../store/loding.model'
import { setErrorTolocalStorage } from './error'
import { popShow } from '../manager/mall.event'
import { eventBus } from './eventBus'
/**
 * @param {String} url config의 API_PATH
 * @param {Object} data data 객체
 * @param {String} type 기본 GET, 포스트는 스트링으로
 * processData가 content-type에 맞춰서 데이터를 자동으로 파싱해줘야 하지만
 * 1.x 버전에서는  post 메소드로 보내면 data를 바디에 urlencoded 형태로 보내어 post일떄는 processData : false로 보내자
 */
export function $ajax(url, data, type) {
  var dataWithTrackingCode = _.extend(data, {
    tracking_code: TRACKING_CODE,
  })
  loadingModel.startLoading()
  return $.ajax({
    url: API_ENDPOINT + url,
    type: type || 'GET',
    xhrFields: {
      withCredentials: true,
    },
    contentType: 'application/json',
    dataType: 'json',
    data:
      type === 'POST'
        ? JSON.stringify(dataWithTrackingCode)
        : dataWithTrackingCode,
    processData: type === 'POST' ? false : true,
    error: function (jqXHR, textStatus, errorThrown) {
      var error = new Error('AJAX 에러')
      error.jqXHR = jqXHR
      error.textStatus = textStatus
      error.errorThrown = errorThrown

      if (
        jqXHR.status === STATUS.unauthorized ||
        jqXHR.status === STATUS.conflict
      ) {
        authError()
      } else {
        if (NODE_ENV === 'development') {
          devErrorMessage(error)
        } else {
          errorMessage()
        }
      }

      setErrorTolocalStorage(JSON.stringify(jqXHR.responseText))
      loadingModel.endLoading()
      throw error
    },
  }).always(function () {
    loadingModel.endLoading()
  })
}

function devErrorMessage(error) {
  popShow({
    title: '개발용 에러 메시지',
    message:
      '<textarea style="height: 233px;width: 353px; font-size:12px; line-height:1.2;">' +
      JSON.stringify(error, null, 4) +
      '</textarea>',
    onClose: function () {
      this.hide()
    },
  })
}

function errorMessage() {
  popShow({
    title: '포커몰 이용불가',
    message:
      '알수 없는 문제가 발생 했습니다. <br />  잠시 후 다시 시도 부탁 드립니다. <br /><span>계속 이용이 어려우 실 경우 고객센터로 문의 부탁 드립니다.</span>',
    confirmText: '도움말',
    onConfirm: function () {
      window.open(LINK.HELP, '_blank')
    },
    onClose: function () {
      eventBus.trigger('mallRemove')
    },
  })
}

function authError() {
  popShow({
    title: '죄송합니다.',
    message: '로그인 정보가 유효하지 않습니다.',
    // confirmText: '도움말',
    // onConfirm: function() {
    //   window.open(LINK.HELP, '_blank')
    // },
    onClose: function () {
      window.location.reload()
    },
  })
}
